import React, { Component } from 'react';
import { Link } from 'react-router';
import Request from '../Request';
import Box from '../componentes/Box';

class Home extends Component {
  render() {
    return (
      <div>
        <Box titulo="Bem vindo ao Protocolo Web!" tipo="primary">
          <p>Através desta funcionalidade, você poderá consultar os processos e verificar o andamento das suas solicitações.</p>
          <h4>O que posso fazer?</h4>
          <p>Para consultar um determinado processo, você irá precisar da Chave de Acesso do processo. A partir desta informação será possível consultar o andamento do processo e identificar a localização e status atual do mesmo.</p>
          <h4>Como consultar?</h4>
          <p>Acesse o Menu Principal Protocolo // <Link to="/protocolo/consultar"><span>Consultar Protocolo</span></Link>, informe a Chave de Acesso do processo e clique em Consultar. Será possível verificar todos os andamentos que este processo sofreu, além de visualizar sua atual localização. Se desejar, imprima o relatório de andamentos, para isso basta clicar no botão Imprimir.</p>
          <p>Para realizar uma nova consulta, basta informar uma nova Chave de Acesso no filtro de busca e repetir os procedimentos acima.</p>
        </Box>
        <img className="center-block hidden-xs hidden-sm" src={Request.getUrlBrasao()} alt="Brasão" width="140" height="140" />
        <img className="center-block visible-xs visible-sm" src={Request.getUrlBrasao()} alt="Brasão" width="100" height="100" />
      </div>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/modulos/layout/Home.js